import axiosConfig from './axiosConfig'

export const handleRegion = async (regionEndpointUrl) => {
  axiosConfig.defaults.baseURL = regionEndpointUrl
}

export { default as apiExternalUrl } from './apiExternalUrl'
export { axiosConfig }
